export const DEFAULT_SIGNIFICANT_FIGURES = 3;

export interface SignificantFiguresSetting {
  id?: string;
  defaultSignificantFigures: number;
  useStrictRounding: boolean;
}

export const DEFAULT_SIGNIFICANT_FIGURES_SETTING: SignificantFiguresSetting = {
  id: undefined,
  defaultSignificantFigures: DEFAULT_SIGNIFICANT_FIGURES,
  useStrictRounding: false
};
